#import "../../../../../../../../common/graphql/EntityDocumentsFields.graphql"

query AttachableTravelAuthorizationDocuments(
  $first: Int
  $after: Cursor
  $travelAuthorizationId: UUID!
  $documentTypeId: Int
  $orderBy: [EntityDocumentsOrderBy!]
  $filter: EntityDocumentFilter
) {
  attachableTravelAuthorizationDocuments(
    first: $first
    after: $after
    travelAuthorizationId: $travelAuthorizationId
    orderBy: $orderBy
    filter: $filter
    documentTypeId: $documentTypeId
  ) {
    nodes {
      ...EntityDocumentsFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
